import "./ctabutton.css";
import { DynamicIcon } from "lucide-react/dynamic";

export default function CtaButton({
  onClick = () => alert("test"),
  children,
  size = 40,
  tip = "button",
  style = {}
}) {
  return (
    <div className="e1-cta-wrapper" style={style}>
      <div
        className="e1-cta-content"
        style={{ "--size": `${size}px`, "--icon-size": `${size * 0.625}px` }}
      >
        <span
          onClick={onClick}
          aria-label={tip}
          data-social={tip}
          className="link"
        >
          <DynamicIcon name={children} />
        </span>
        <div className="tooltip">{tip}</div>
      </div>
    </div>
  );
}
